import { render, staticRenderFns } from "./employment.vue?vue&type=template&id=663b5909&scoped=true"
import script from "./employment.vue?vue&type=script&lang=js"
export * from "./employment.vue?vue&type=script&lang=js"
import style0 from "../../utils/commen.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./employment.vue?vue&type=style&index=1&id=663b5909&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663b5909",
  null
  
)

export default component.exports